import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { INSPIRATION_IMAGES } from '../../data/siteData';

export default function InspirationGallery() {
  const { t } = useLang();
  return (
    <section className="bg-[#0B0D0F] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#D4AF37] text-xs font-mono tracking-[0.25em] uppercase">{t.inspiration.label}</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-3 font-outfit">{t.inspiration.heading}</h2>
          <p className="text-slate-400 mt-4 max-w-2xl mx-auto text-sm">{t.inspiration.desc}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {INSPIRATION_IMAGES.map((item, i) => (
            <div key={i} className="group relative overflow-hidden rounded-lg aspect-[4/3]">
              <img src={item.image} alt={`${t.inspiration.cats[item.category] || item.category} ${t.inspiration.badge.toLowerCase()}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="text-[10px] text-[#D4AF37] font-mono tracking-wider uppercase bg-black/50 px-2 py-1 rounded">{t.inspiration.badge}</span>
                <h3 className="text-white font-semibold mt-2 font-outfit">{t.inspiration.cats[item.category] || item.category}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
